import {L10n, setCulture} from '@syncfusion/ej2-base';
import {Component} from '@angular/core';

setCulture('de-CH');

L10n.load({
  'de-CH': {
    grid: {
      EmptyRecord: 'Keine Einträge gefunden.',
      Add: 'Hinzufügen',
      Edit: 'Bearbeiten',
      Delete: 'Löschen',
      Update: 'Speichern',
      Cancel: 'Abbrechen',
      Search: 'Suchen',
      EditOperationAlert: 'Bitte wählen Sie einen Eintrag aus.',
      DeleteOperationAlert: 'Bitte wählen Sie einen Eintrag aus.',
    },
    pager: {
      currentPageInfo: '{0} von {1} Seiten',
      totalItemsInfo: '({0} Einträge)',
      firstPageTooltip: 'Zur ersten Seite',
      lastPageTooltip: 'Zur letzten Seite',
      nextPageTooltip: 'Zur nächsten Seite',
      previousPageTooltip: 'Zurück zur letzten Seite',
      nextPagerTooltip: 'Zum nächsten Pager',
      previousPagerTooltip: 'Zum vorherigen Pager'
    }
  },
  'fr-CH': {
    grid: {
      EmptyRecord: 'Rien n\'a été trouvé.',
      Add: 'Ajouter',
      Edit: 'Editer',
      Delete: 'Annule',
      Update: 'Sauvegarder',
      Cancel: 'Abandonner',
      Search: 'Chercher',
      EditOperationAlert: 'Veuillez, s\'il vous plaît, sélectionner un record.',
      DeleteOperationAlert: 'Veuillez, s\'il vous plaît, sélectionner un record.',
    },
    pager: {
      currentPageInfo: '{0} de {1} Page',
      totalItemsInfo: '{0} articles',
      firstPageTooltip: 'Première page',
      lastPageTooltip: 'Dernière page',
      nextPageTooltip: 'Page suivante',
      previousPageTooltip: 'Page précédente',
      nextPagerTooltip: 'Prochain paragraphe',
      previousPagerTooltip: 'Précédent paragraphe'
    }
  },
  'it-CH': {
    grid: {
      EmptyRecord: 'Non sono state trovate voci.',
      Add: 'Aggiungere',
      Edit: 'Modificare',
      Delete: 'Cancellare',
      Update: 'Salvare',
      Cancel: 'Annullare',
      Search: 'Ricerca',
      EditOperationAlert: 'Selezionare un disco.',
      DeleteOperationAlert: 'Selezionare un disco.',
    },
    pager: {
      currentPageInfo: '{0} di {1} pagine',
      totalItemsInfo: '({0} voci)',
      firstPageTooltip: 'Alla prima pagina',
      lastPageTooltip: 'All\'ultima pagina',
      nextPageTooltip: 'Alla pagina successiva',
      previousPageTooltip: 'Indietro all\'ultima pagina',
      nextPagerTooltip: 'Al prossimo pager',
      previousPagerTooltip: 'Al pager precedente'
    }
  },
  'en-GB': {
    grid: {
      EmptyRecord: 'No records displayed.',
      Add: 'Add',
      Edit: 'Edit',
      Delete: 'Delete',
      Update: 'Update',
      Cancel: 'Cancel',
      Search: 'Search',
      EditOperationAlert: 'Please select a record.',
      DeleteOperationAlert: 'Please select a record.',
    },
    pager: {
      currentPageInfo: '{0} of {1} pages',
      totalItemsInfo: '({0} records)',
      firstPageTooltip: 'First page',
      lastPageTooltip: 'Last page',
      nextPageTooltip: 'Next page',
      previousPageTooltip: 'Previous page',
      nextPagerTooltip: 'Next Pager',
      previousPagerTooltip: 'Previous Pager'
    }
  }
});
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent {
  constructor() {}
}
